import RsaGestionePazientiAdi from "../";

const routes = [
    {
        name: "RsaGestionePazientiAdiListPage",
        path: "/rsagestionepazientiadi",
        component: RsaGestionePazientiAdi.RsaGestionePazientiAdiListPage,
        meta: { title: " Gestione Ambulatoriale" },
    },
];

export default routes;
